export default {
  data() {
    return {
      less1950: false,
      from1950to1990: false,
      more1990: false,
      T_from:null,
      T_to:null,
      T_calck:null,
      T_on_max: null,
      T_on_min: null,
      is_debug: false,
      is_period_slider: false,

      year_from_in: 0,
      year_to_in: 0,
    }
  },
  computed: {
    is_show_filter_preiod: {
      get () {
        if ( this.$store.getters.periods==null || this.$store.getters.periods.length==0 || $.isEmptyObject(this.$store.getters.periods) ) {
          if ( this.$store.getters.filters.year_from!=null || this.$store.getters.filters.year_to!=null ){
            //чтобы теги поставить
            this.calck_periods();
          }
          return false;
        }
        this.calck_periods();
        return true;
      },
    },

    //границы периода
    min_from: {
      get () {
        if ( this.$store.getters.periods==null || this.$store.getters.periods.length==0 || $.isEmptyObject(this.$store.getters.periods) ) return 0;
        return this.$store.getters.periods.min_from;
      },
    },
    max_to: {
      get () {
        if ( this.$store.getters.periods==null || this.$store.getters.periods.length==0 || $.isEmptyObject(this.$store.getters.periods) ) return new Date().getFullYear();
        return this.$store.getters.periods.max_to;
      },
    },

    //границы самого активного периода
    period_min: {
      get () {
        if ( this.$store.getters.periods==null || this.$store.getters.periods.length==0 || $.isEmptyObject(this.$store.getters.periods) ) return 1950;
        return this.$store.getters.periods.period_min;
      },
    },
    period_max: {
      get () {
        if ( this.$store.getters.periods==null || this.$store.getters.periods.length==0 || $.isEmptyObject(this.$store.getters.periods) ) return 1990;
        return this.$store.getters.periods.period_max;
      },
    },

    //выбранный период
    year_from: {
      get () {
        let value=this.$store.getters.filters.year_from;

        clearTimeout(this.T_on_min);
        this.T_on_min=setTimeout( () =>{
          this.on_periodChange(value, null);
          this.set_tag_min(value);
          this.year_from_in=value;
        }, 100);

        return value;
      },
      set (value) {
        this.year_from_in=value;

        if (this.is_period_slider){
          clearTimeout( this.T_from );
          this.T_from=setTimeout( ()=>{
            this.set_year_from(value);
          }, 700 );
        }
      }
    },
    year_to: {
      get () {
        let value=this.$store.getters.filters.year_to;

        clearTimeout(this.T_on_max);
        this.T_on_max=setTimeout( ()=>{
          this.on_periodChange(null, value);
          this.set_tag_max(value);
          this.year_to_in=value;
        }, 100 );

        return value;
      },
      set (value) {
        this.year_to_in=value;

        if (this.is_period_slider){
          clearTimeout( this.T_to );
          this.T_to=setTimeout( ()=>{
            this.set_year_to(value);
          }, 700 );
        }
      }
    },

    label_less1950: {
      get () {
        return this.$t("message.year1950").replace('1950', this.period_min);
      }
    },
    label_from1950to1990: {
      get () {
        let res=this.$t("message.year19501990").replace('1950', '_from_').replace('1990', '_to_');
        res=res.replace('_from_', this.period_min).replace('_to_', this.period_max);
        return res;
      }
    },
    label_more1990: {
      get () {
        return this.$t("message.more1990").replace('1990', this.period_max);
      }
    },
  },
  methods: {
    set_year_from: function(value){
      if (this.year_from===value) return;

      let val_str=value;
      if ( val_str!=null && val_str!==false && val_str>0 ) val_str=val_str.toString();

      this.$store.dispatch('setFilters',{'p':1, year_from: val_str}).then( () => {
        this.set_tag_min(val_str);
        this.calck_periods();
      });
    },

    set_year_to: function(value){
      if (this.year_to===value) return;

      let val_str=value;
      if ( val_str!=null && val_str!==false && val_str>0 ) val_str=val_str.toString();

      this.$store.dispatch('setFilters',{'p':1, year_to: val_str}).then( () => {
        this.set_tag_max(val_str);
        this.calck_periods();
      });
    },

    set_tag_min:function(value){
      if (value>0) this.$store.dispatch('setTags',{year_from: {value: this.$t("message.YearFrom")+' '+value, key: value}}).then(()=>{});
      else this.$store.dispatch('setTags',{year_from: {}}).then(()=>{});
    },

    set_tag_max: function(value){
      if (value>0) this.$store.dispatch('setTags',{year_to: {value: this.$t("message.YearBefore")+' '+value, key: value}})
      else this.$store.dispatch('setTags',{year_to: {}}).then(()=>{});
    },

    calck_periods: function(){
      clearTimeout( this.T_calck );
      this.T_calck=setTimeout( ()=>{
        let y_from=this.year_from;
        let y_to=this.year_to;

        if ( y_from==null || y_from=='' || (y_from==this.min_from && this.min_from!=this.period_min) ) y_from=false;
        if ( y_to==null || y_to=='' || (y_to==this.max_to && this.max_to!=this.period_max) ) y_to=false;

        if (this.is_debug) {
          console.log('y_from='+y_from, 'y_to='+y_to);
          console.log('period_min='+this.period_min, 'period_max='+this.period_max);
        }

        this.less1950=false;
        this.from1950to1990=false;
        this.more1990=false;

        if ( y_from==false && y_to==this.period_min ){
          if (this.is_debug) console.log('if_1');
          this.less1950=true;
          this.from1950to1990=false;
          this.more1990=false;
        }
        else if ( y_from==false && y_to==this.period_max ) {
          if (this.is_debug) console.log('if_2');
          this.less1950=true;
          this.from1950to1990=true;
          this.more1990=false;
        }
        else if ( y_from==false && y_to==false ) {
          if (this.is_debug) console.log('if_3');
          this.less1950=false;
          this.from1950to1990=false;
          this.more1990=false;
        }
        else if ( y_from==this.period_min && y_to==this.period_max ) {
          if (this.is_debug) console.log('if_4');
          this.less1950=false;
          this.from1950to1990=true;
          this.more1990=false;
        }
        else if ( y_from==this.period_min && y_to==false ) {
          if (this.is_debug) console.log('if_5');
          this.less1950=false;
          this.from1950to1990=true;
          this.more1990=true;
        }
        else if ( y_from==this.period_max && y_to==false ) {
          if (this.is_debug) console.log('if_6');
          this.less1950=false;
          this.from1950to1990=false;
          this.more1990=true;
        }

        if ( this.min_from>=this.period_min ) this.less1950=false;
        if ( this.max_to<=this.period_max ) this.more1990=false;

        if (this.is_debug) {
          console.log('less1950=' + this.less1950);
          console.log('from1950to1990=' + this.from1950to1990);
          console.log('more1990=' + this.more1990);
          console.log('-----------');
        }
      },10 );
    },

    periodChange: function(prop){
      if (this.less1950 && !this.from1950to1990 && this.more1990) {
        if ( prop=='less1950' ) this.more1990=false;
        else if ( prop=='more1990' ) this.less1950=false;
        else if ( prop=='from1950to1990' ) this.more1990=false;
      }

      let y_from=false;
      let y_to=false;

      if ( this.less1950 ){
        y_from=false;
        y_to=this.period_min;
        if ( this.from1950to1990 ){
          y_from=false;
          y_to=this.period_max;
          if ( this.more1990 ){
            y_from=false;
            y_to=false;
          }
        }
        else if ( this.more1990 ){
          //не должно быть такого
        }
      }
      else if ( this.from1950to1990 ){
        y_from=this.period_min;
        y_to=this.period_max;

        if ( this.more1990 ){
          y_from=this.period_min;
          y_to=false;
        }
      }
      else if ( this.more1990 ){
        y_from=this.period_max;
        y_to=false;
      }

      if (this.is_debug) {
        console.log('set y_from='+y_from);
        console.log('set y_to='+y_to);
      }

      this.set_year_from(y_from);
      this.set_year_to(y_to);
    },

    on_periodChange: function(y_from, y_to){},
  },

  created   : function () {
    this.$store.dispatch ('addUsedFilters', 'Periods');
  },
  destroyed : function () {
    this.$store.dispatch ('removeUsedFilters', 'Periods');
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/FilterPeriodMix.js
// module id = null
// module chunks = 